// extracted by mini-css-extract-plugin
export var editButton = "partenaires-module--edit-button--611c7";
export var editButtonTitle = "partenaires-module--edit-button-title--e8613";
export var listPartenairesContainer = "partenaires-module--list-partenaires-container--f6a55";
export var partenaireDescription = "partenaires-module--partenaire-description--09fdd";
export var partenaireItemDescription = "partenaires-module--partenaire-item-description--94d8d";
export var partenairesContainer = "partenaires-module--partenaires-container--6145f";
export var partenairesTitle = "partenaires-module--partenaires-title--a14fb";